module.exports = __webpack_public_path__ + "static/img/wx.05fe05b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wx.png
// module id = qSza
// module chunks = 28